document.addEventListener("DOMContentLoaded", () => {
    const ele = document.querySelector("meta[http-equiv=refresh]");
    if(ele) {
        window.location.href = ele.getAttribute("data-url");
    }
});